// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combo-box__item_shifted_3733632b.combo-box__item_shifted_3733632b {
  padding-left: 2.667rem;
}
.cell-combo-box_3733632b {
  display: flex;
  justify-content: space-between;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: inherit;
  overflow: hidden;
  padding-top: 0.25rem;
  padding-right: 0.667rem;
  padding-left: 0.667rem;
  color: #26649e;
}
.cell-combo-box_3733632b:hover {
  color: #a26426;
}
.cell-combo-box_3733632b .combo-box__icon_3733632b {
  display: none;
  margin-left: 0.667rem;
  color: #1d5080;
  font-size: 1.584rem;
  font-weight: 600;
}
.cell-combo-box_3733632b:hover .combo-box__icon_3733632b {
  display: initial;
}
.cell-combo-box_3733632b .combo-box__icon-shown_3733632b {
  display: initial;
}
.cell-combo-box_3733632b .combo-box__placeholder_3733632b {
  color: #657682;
  font-style: italic;
}
.cell-combo-box_disabled_3733632b {
  color: #84919b;
  cursor: inherit;
}
.cell-combo-box_disabled_3733632b .combo-box__placeholder_3733632b {
  color: #84919b;
}
.cell-combo-box_disabled_3733632b .combo-box__icon_3733632b {
  color: #c1c8cd;
}
.cell-combo-box_disabled_3733632b:focus,
.cell-combo-box_disabled_3733632b:active,
.cell-combo-box_disabled_3733632b:hover {
  color: #84919b;
  cursor: inherit;
}
.cell-combo-box_disabled_3733632b:focus .combo-box__placeholder_3733632b,
.cell-combo-box_disabled_3733632b:active .combo-box__placeholder_3733632b,
.cell-combo-box_disabled_3733632b:hover .combo-box__placeholder_3733632b {
  color: #84919b;
}
.cell-combo-box_disabled_3733632b:focus .combo-box__icon_3733632b,
.cell-combo-box_disabled_3733632b:active .combo-box__icon_3733632b,
.cell-combo-box_disabled_3733632b:hover .combo-box__icon_3733632b {
  color: #c1c8cd;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"combo-box__item_shifted": `combo-box__item_shifted_3733632b`,
	"cell-combo-box": `cell-combo-box_3733632b`,
	"combo-box__icon": `combo-box__icon_3733632b`,
	"combo-box__icon-shown": `combo-box__icon-shown_3733632b`,
	"combo-box__placeholder": `combo-box__placeholder_3733632b`,
	"cell-combo-box_disabled": `cell-combo-box_disabled_3733632b`
};
export default ___CSS_LOADER_EXPORT___;
